import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../pages/Landing";
import StoreFront from "../pages/StoreFront";
import CartPage from "../components/cart/CartPage";
import OrderConfirmationPage from "../components/store/OrderConfirmation";
import CustomerLogin from "../components/store/CustomerLogin";
import CustomerRegister from "../components/store/CustomerRegister";
import CustomerProfile from "../components/store/ProfilePage";

const AppRoutes: React.FC = () => {
  const hostname = window.location.hostname;

  // Check if the current URL matches the custom domain pattern
  const isCustomDomain =
    !hostname.includes("redbirdtab.com") &&
    hostname !== "localhost" &&
    !hostname.startsWith("192.168.1.144") &&
    !hostname.endsWith(".vercel.app");

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      {isCustomDomain ? (
        <>
          <Route path="/orders" element={<StoreFront />} />
          <Route path="/orders/cart" element={<CartPage />} />
          <Route
            path="/orders/order-confirmation"
            element={<OrderConfirmationPage />}
          />
          <Route path="/orders/customer-login" element={<CustomerLogin />} />
          <Route
            path="/orders/customer-register"
            element={<CustomerRegister />}
          />
          <Route
            path="/orders/customer-profile"
            element={<CustomerProfile />}
          />
        </>
      ) : (
        <>
          <Route path="/:merchant" element={<StoreFront />} />
          <Route path="/:merchantSlug/cart" element={<CartPage />} />
          <Route
            path="/:merchantSlug/order-confirmation"
            element={<OrderConfirmationPage />}
          />
          <Route
            path="/:merchantSlug/customer-login"
            element={<CustomerLogin />}
          />
          <Route
            path="/:merchantSlug/customer-register"
            element={<CustomerRegister />}
          />
          <Route
            path="/:merchantSlug/customer-profile"
            element={<CustomerProfile />}
          />
        </>
      )}
    </Routes>
  );
};

export default AppRoutes;
